package navigation.settings.imagegallery.imageInfos

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.file.ui.imageinfos.ImageInfosEvent
import com.essntl.features.file.ui.imageinfos.ImageInfosState
import com.essntl.features.file.ui.imageinfos.ImageInfosViewModel
import com.essntl.features.organization.domain.repository.OrganizationRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository
import com.essntl.toastmanager.ToastManager

class ImageInfosScreenModel(
    fileRepository: FileRepository,
    proposalRepository: ProposalRepository,
    travelAgentRepository: TravelAgentRepository,
    serviceRepository: ServiceRepository,
    categoryRepository: CategoryRepository,
    organizationRepository: OrganizationRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<ImageInfosState>(ImageInfosState()) {

    private val viewModel =
        ImageInfosViewModel(
            fileRepository = fileRepository,
            proposalRepository = proposalRepository,
            travelAgentRepository = travelAgentRepository,
            serviceRepository = serviceRepository,
            categoryRepository = categoryRepository,
            organizationRepository = organizationRepository,
            loadingManager = loadingManager,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: ImageInfosEvent) = viewModel.onEvent(event)
}